import React from "react"
import "./maintenance.scss"

const MaintenancePage = () => {
  return (
    <div className="maintenance-container" dir="rtl">
      <div className="maintenance-wrapper">
        <div className="maintenance-left-decoration"></div>
        <div className="maintenance-right-decoration"></div>

        <div className="maintenance-content">
          {/* Header Section */}
          <div className="maintenance-header">
            <div className="maintenance-icon-wrapper">
              <i className="mdi mdi-wrench-outline"></i>
            </div>
          </div>

          {/* Main Content */}
          <div className="maintenance-body">
            <h1 className="maintenance-title">وضع الصيانة</h1>
            
            <div className="maintenance-status-badge">
              <span className="badge-dot"></span>
              <span className="badge-text">قيد الصيانة</span>
            </div>

            <div className="maintenance-messages">
              <p className="maintenance-message-primary">
                نحن حالياً نقوم بأعمال صيانة دورية لتحسين خدمتنا
              </p>
              <p className="maintenance-message-secondary">
                نعتذر عن أي إزعاج قد تواجهه. يرجى العودة لاحقاً!
              </p>
            </div>

            {/* Features During Maintenance */}
            <div className="maintenance-info">
              <div className="info-item">
                <div className="info-icon">
                  <i className="mdi mdi-heart-outline"></i>
                </div>
                <p>نحن نعمل بجد لتحسين تجربتك</p>
              </div>
              <div className="info-item">
                <div className="info-icon">
                  <i className="mdi mdi-shield-check-outline"></i>
                </div>
                <p>بيانات آمنة ومحمية</p>
              </div>
            </div>

            {/* Contact Support */}
            <div className="maintenance-support">
              <p className="support-label">لديك استفسار طارئ؟</p>
              <a href="mailto:support@dbsaloni.com" className="support-link">
                <i className="mdi mdi-email-outline"></i>
                support@dbsaloni.com
              </a>
            </div>

            {/* Timestamp */}
            <div className="maintenance-timestamp">
              <p>
                آخر تحديث: {new Date().toLocaleDateString('ar-SA')} الساعة{" "}
                {new Date().toLocaleTimeString('ar-SA')}
              </p>
            </div>
          </div>
        </div>

        <div className="maintenance-footer-decoration"></div>
      </div>
    </div>
  )
}

export default MaintenancePage
